import { render, staticRenderFns } from "./BaseSet.vue?vue&type=template&id=42021020&scoped=true&"
import script from "./BaseSet.vue?vue&type=script&lang=js&"
export * from "./BaseSet.vue?vue&type=script&lang=js&"
import style0 from "./BaseSet.vue?vue&type=style&index=0&id=42021020&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42021020",
  null
  
)

export default component.exports